export const allHelpRoles = ['qa-user', 'help-user', 'help-qa-user'];
export const helpRoles = ['help-user', 'help-qa-user'];
export const qaRoles = ['qa-user', 'help-qa-user'];
export const userRoles = ['admin', 'user'];